module.exports = __webpack_public_path__ + "img/M-4.a5b67093.png";